class NetsuiteController extends AbstractIntegrationController
	@register()
	@inject 'configuration',
		'configurationOptions'
		'vatRates'
		'users'
		'suppliers'
		'Products'
		'priceRegions'
		'shops'
		'BulkDataRepository'
		'VatRateRepository'
		'IntegrationRepository'

	integrationId: 'netsuite'

	initialize: ->
		# There is already config set, but options has failed to load
		if !_.isEmpty(@configuration) && _.isEmpty(@configurationOptions)
			@allowSync = true
			@confirmed = true
			@showSynchronizationButton = false
			@showMappings = false

			@addErrorMessage('credentials', 'wbo.integration.netsuite.error.invalid_credentials')
			@showActionButtons()

			return
		else
			@allowSync = @Products.data.length == 0
			@confirmed = !_.isEmpty @configuration
			@showSynchronizationButton = @confirmed
			@showMappings = @confirmed

		# Used to disable form when sync is not allowed
		@emptyValue = if @allowSync then true else null

		@configuration.is_intercompany_active ?= false
		@configuration.shops ?= {}

		if @showMappings
			for vatRate in @vatRates
				vatRate.name = "#{vatRate.name} (#{@VatRateRepository.getPercentageText(vatRate.percentage)}%)"

			@setConfigurationData()
			@setPossibleImageField()

		@showActionButtons()

	setConfigurationData: ->
		@configuration.shops ?= {}

		for shop in @shops
			@configuration.shops[shop.id] ?=
				shop_id: shop.id
				is_active: true
				customer_id: null
			# For old configuration only
			@configuration.shops[shop.id].shop_id ?= shop.id

		@configuration.suppliers ?= {}

		for supplier in @suppliers
			@configuration.suppliers[supplier.id] ?=
				supplier_id: supplier.id
				is_active: true
				customer_id: null

	showActionButtons: (showActionButtons = @showMappings) ->
		@showFormActionButtons = showActionButtons
		@additionalButtonsTemplate = '@app/integration/netsuite/netsuite.additional-buttons.view.html'

	getConfigurationOptions: ->
		@IntegrationRepository
			.customPost @integrationId, 'configuration_options', @configuration
			.then (response) =>
				@configuration.is_active = true
				@configurationOptions = response.data
				@showMappings = true
				@setConfigurationData()
				@setPossibleImageField()
				@showActionButtons()
			.catch (response) =>
				@handleErrors(response, @headerText)

	setPossibleImageField: ->
		if !@configuration.product_image_field_id?
			possibleField = @getPossibleCustomField('image')

			if possibleField?
				@configuration.product_image_field_id = possibleField.id

	getPossibleCustomField: (search) ->
		return if !@configurationOptions.custom_fields?

		for field in @configurationOptions.custom_fields
			if field.script_id.includes(search)
				return field

	save: ->
		@saving = true

		for data in @configuration.shops
			data.customer_id = null if !data.customer_id?

		super(@configuration)
			.then (response) =>
				@showSynchronizationButton = true
				@configuration = response.data
				@confirmed = true
			.finally =>
				@saving = false
				@showActionButtons()

	afterDisconnect: ->
		@showSynchronizationButton = false
		@configuration = {}
		@configurationOptions = {}
		@confirmed = false
		@showMappings = false

		@showActionButtons()

	synchronize: ->
		@saving = true
		@IntegrationRepository
			.customPost @integrationId, 'synchronize'
			.then =>
				@configurationOptions.last_synchronization = 0
				@ToastService.add(
					@$filter('translate')('general.synchronization.complete').toString(),
					@$filter('translate')('general.synchronize')
					@integrationId
					'success'
				)
			.finally =>
				@saving = false

	sendDeleteRequest: ->
		@saving = true

		@BulkDataRepository
			.delete('products')
			.then =>
				@allowSync = true
				@ToastService.add(
					@$filter('translate')('alert.delete.task.scheduled').toString(),
					@$filter('translate')('general.delete')
					'general.products'
					'success'
				)
			.catch (response) =>
				@handleErrors response, 'general.products'
			.finally =>
				@saving = false
